export class Colaborador {}
